//
// The "supplies on record" line shown above the consultation type options, read from the weight treatment plans
// on the patient record. An unavailable record is never reported as "none".
//

import type { AHTSupplyEvent } from "@/lib/ahtTreatmentPlanData";

const PREFIX = "Weight management supplies on record at this pharmacy: ";

const productName = (e: AHTSupplyEvent): string =>
  e.brandName ?? `${e.drugId.charAt(0).toUpperCase()}${e.drugId.slice(1)}`;

const formatDate = (iso: string): string =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

export function weightSupplyHistoryLine(plans: unknown): string {
  if (!Array.isArray(plans)) return `${PREFIX}not available`;
  const events = plans.flatMap((p) =>
    p && typeof p === "object" && "resolvedDrugId" in p && Array.isArray((p as { supplyHistory?: unknown }).supplyHistory)
      ? ((p as { supplyHistory: AHTSupplyEvent[] }).supplyHistory)
      : [],
  );
  const dated = events.filter((e) => typeof e.supplyDate === "string" && !Number.isNaN(Date.parse(e.supplyDate)));
  if (dated.length === 0) return `${PREFIX}none`;
  const last = dated.reduce((a, b) => (Date.parse(b.supplyDate) > Date.parse(a.supplyDate) ? b : a));
  return `${PREFIX}Last supply: ${productName(last)}, ${formatDate(last.supplyDate)}`;
}
